export default [
  {
    path: '/login',
    name: 'login',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'login'  */ '@/views/login')
  },
  {
    path: '/home',
    name: 'home',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'home'  */ '@/views/home')
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'productDetail'  */ '@/views/productDetail')
  },
  {
    path: '/collect',
    name: 'collect',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'collect'  */ '@/views/collect')
  },
  {
    path: '/history',
    name: 'history',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'history'  */ '@/views/history')
  },
  {
    path: '/match',
    name: 'match',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'match'  */ '@/views/match')
  },
  {
    path: '/newMatch',
    name: 'newMatch',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'match'  */ '@/views/match/new.vue')
  },
  {
    path: '/shopcart',
    name: 'shopcart',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'shopcart'  */ '@/views/shopcart')
  },
  {
    path: '/productList',
    name: 'productList',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'productList'  */ '@/views/productList')
  },
  {
    path: '/about',
    name: 'about',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'about'  */ '@/views/about')
  },
  {
    path: '/testView',
    name: 'testView',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'about'  */ '@/views/testView')
  },
  {
    path: '/storeProductList',
    name: 'storeProductList',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'storeProductList'  */ '@/views/storeProductList')
  },
  {
    path: '/storeProductDetail',
    name: 'storeProductDetail',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'productDetail'  */ '@/views/storeProductDetail')
  },
  {
    path: '/caseList',
    name: 'caseList',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'caseList'  */ '@/views/caseList')
  },
  {
    path: '/caseDateil',
    name: 'caseDateil',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'caseDateil'  */ '@/views/caseDateil')
  },
  {
    path: '/bookList',
    name: 'bookList',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'caseDateil'  */ '@/views/shopcart/bookList')
  },
  {
    path: '/brand',
    name: 'brand',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: 'brand'  */ '@/views/brand/index')
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js